var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"content":_vm.volumeOn
    ? _vm.$t('chat.turnVolumeOff')
    : _vm.$t('chat.turnVolumeOn'),"effect":"dark","placement":"top"}},[_c('el-button',{staticClass:"e-volume",attrs:{"type":"ghost"},on:{"click":_vm.toggleVolume}},[(_vm.volumeOn)?[_c('icon-volume-on',{staticClass:"e-volume__icon",attrs:{"role":"presentation"}})]:[_c('icon-volume-off',{staticClass:"e-volume__icon",attrs:{"role":"presentation"}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }